import {Undef} from 'app/interface';
import {renderPlaceholder} from 'app/utils/replacePlaceholder/renderPlaceholder';
import {MustacheTags} from 'app/utils/template/interface';
import {templateDate} from 'app/utils/template/templateDate';

import {GemSettings} from '../config/interface';

/**
 * Replace placeholders in given string, where placeholders are closed with double brackets(like {{placeholder}} )
 * @example
 * const value = 'cookie_access_token={{cookies.access_token_social}}&qs_session_storage={{qs_params.test}}&gem_settings.wmode={{gemSettings.wmmode}}&obj={{obj.link}}'
 * const results = replacePlaceholders({value, additionalValues: {obj:{link:'liiiiink'}}});
 * const results = replacePlaceholders({value, gemSettings: {}, skipStorage: true}); // `storage.*` parameters won't be rendered
 *
 * console.log(results);
 * // cookie_access_token=sdfadfgsad&qs_session_storage=test&gem_settings.wmode=edit&obj=liiiiink
 */
export function replacePlaceholders({template, gemSettings, additionalValues = {}, skipStorage = false, tags, hydrated}: ReplacePlaceholdersParams) {
    return renderPlaceholder(templateDate)({
        template,
        gemSettings,
        additionalValues,
        skipStorage,
        tags,
        hydrated,
    });
}

export function replacePlaceholdersInObject({obj, gemSettings, additionalValues}: ReplacePlaceholdersInObjectParams): Record<string, any> {
    return JSON.parse(
        replacePlaceholders({
            template: JSON.stringify(obj),
            gemSettings,
            additionalValues,
        }),
    );
}

type ReplacePlaceholdersParams = {
    template: string;
    gemSettings: GemSettings;
    additionalValues?: any;
    skipStorage?: boolean;
    tags?: Undef<MustacheTags>;
    hydrated?: boolean;
};

type ReplacePlaceholdersInObjectParams = {
    obj: Record<string, unknown>;
    gemSettings: GemSettings;
    additionalValues?: any;
};
